exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theatre-seats{width:calc(100% - 400px);border:0}.scan-true>circle{stroke:#34a853;stroke-width:4.5!important;paint-order:stroke;r:3}.row-numbers text{font-size:8px;transform:translateY(-1px);font-weight:700}.theatre-container{position:relative}.theatre-container .back-button{position:absolute;top:0;left:-25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02224dfc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/AdminTheatre.vue
// module id = 372
// module chunks = 0